import { render } from "./ContratoTab.vue?vue&type=template&id=4ad6b064"
import script from "./ContratoTab.vue?vue&type=script&lang=js"
export * from "./ContratoTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__